import { memo } from "react";
import { ActivityIndicator } from "react-native";
import { View } from "@src/components";
import { StyleSheet, useUnistyles } from "react-native-unistyles";

export const VideoLoadingOverlay = memo(() => {
  const { theme } = useUnistyles();

  return (
    <View style={styles.container}>
      <ActivityIndicator size="large" color={theme.colors.white.default} />
    </View>
  );
});

const styles = StyleSheet.create(() => ({
  container: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    justifyContent: "center",
    alignItems: "center",
    zIndex: 2,
  },
}));
